module.exports = __webpack_public_path__ + "images/direction.1653b0df35632a43959040ccd0aba348.png";